import deepmerge from "deepmerge";
const arrayMerge = (dest, src, opts) => src;
export function merge<T>(dest: Partial<T>, src: Partial<T>): T;
export function merge<T1, T2>(dest: Partial<T1>, src: Partial<T2>): T1 & T2 {
  return deepmerge(dest, src, {
    arrayMerge
  });
}
export default merge;